import React, {Component} from 'react';

class CompetitorsIndirectSelects extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            indirect: '',
        };
    }
    
    onDataChange = (event) => {
        const value = event.target.value;
        if(value!=='select'){
            this.setState({ indirect : value })
            this.props.changeCompetitorsGroupsIndirect(value, this.props.data.competitorId)
        }
    };

    render() {

        return(
            <div className='level-select-box'>
                <div className='form-group'>
                    <i class="fas fa-sort"></i>
                    <select onChange={(e) => { this.onDataChange(e)}} value={this.props.data.indirect} >
                        <option value='select'>Competitor Type</option>
                        <option value='direct'>Direct</option>
                        <option value='indirect'>Indirect</option>
                        <option value='complement'>Complement</option>
                    </select>
                </div>
            </div>
        ) 
    }
}

export default (CompetitorsIndirectSelects);



// WEBPACK FOOTER //
// ./src/components/CompetitiveAnalysis/CompetitorsGroupsIndirect/CompetitorsIndirectSelects/CompetitorsInderectSelects.jsx